import { ReactElement } from 'react';
import { TelemedAppointmentStatus } from 'utils';
import { MappedStatusChip } from './MappedStatusChip';

export const TELEMED_APPT_STATUS_MAP: {
  [status in TelemedAppointmentStatus]: {
    background: {
      primary: string;
      secondary?: string;
    };
    color: {
      primary: string;
      secondary?: string;
    };
  };
} = {
  ready: {
    background: {
      primary: '#FEF3E2',
    },
    color: {
      primary: '#7A4800',
    },
  },
  'pre-video': {
    background: {
      primary: '#C8DFF7',
    },
    color: {
      primary: '#22222d',
    },
  },
  'on-video': {
    background: {
      primary: '#E8E4F5',
    },
    color: {
      primary: '#3a2d6e',
    },
  },
  unsigned: {
    background: {
      primary: '#FCEAEA',
    },
    color: {
      primary: '#B71C1C',
    },
  },
  complete: {
    background: {
      primary: '#D6EAD7',
    },
    color: {
      primary: '#1B5E20',
    },
  },
  cancelled: {
    background: {
      primary: '#FCEAEA',
    },
    color: {
      primary: '#B71C1C',
    },
  },
};

// added to handle different mappers (e.g. IP ones) with same style
export function TelemedAppointmentStatusChip({
  status,
  count,
}: {
  status: TelemedAppointmentStatus;
  count?: number;
}): ReactElement {
  return <MappedStatusChip status={status} count={count} mapper={TELEMED_APPT_STATUS_MAP} />;
}
